<template>
  <div class="notifications">
    <div class="pb-3">
      <p class="text-left font-italic ml-2">Notifications</p>
      <div class="bg-light border add-rounded py-2 px-4">
        <div class="" v-for="n in 3" :key="n">
          <div class="d-flex">
            <img
              src="../assets/kovatek/Mask Group 46.svg"
              alt=""
              class="rounded-circle img-height mt-lg-2"
            />
            <div class="col">
              <p
                class="text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2 mt-3"
              >
                <span class="kova-text">Sun Yeoun W</span> sent a proposal for
                <br />
                <span class="kova-text">Project ID 457896</span>
              </p>
            </div>
          </div>
          <p class="text-right text-dark font-weight-bolder ctrl-size">
            <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30
            minutes ago
          </p>
          <hr v-if="n !== 3" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notifications',
};
</script>

<style scoped>
  .kova-text {
    color: #20409a;
  }
  .bg-kovatek {
    background-color: #20409a;
  }
  .add-rounded {
    border-radius: 10px;
  }
  .ctrl-size {
    font-size: 11px;
  }
  .ctrl-size-2 {
    font-size: 12px;
  }

  .img-height {
    width: 65px;
    height: 65px;
  }
  /* total width */

  /* set button(top and bottom of the scrollbar) */
  .scrollbar::-webkit-scrollbar-button {
    display: none;
  }

  @media screen and (min-width: 992px) and (max-width: 1325px) {
  }

  @media screen and (min-width: 992px) and (max-width: 1200px) {
    .img-height {
      width: 60px;
      height: 60px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
  }

  @media screen and (max-width: 767px) {
  }
</style>
